function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { MiniLD } from "./MiniLD";
var defaultMapPropsToFlag = function(props, flag) {
    return flag;
};
var withMiniLD = function(param) {
    var clientId = param.clientId, user = param.user, flag = param.flag, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? null : _param_placeholder, _param_mapPropsToFlag = param.mapPropsToFlag, mapPropsToFlag = _param_mapPropsToFlag === void 0 ? defaultMapPropsToFlag : _param_mapPropsToFlag, _param_forwardRef = param.forwardRef, forwardRef = _param_forwardRef === void 0 ? false : _param_forwardRef;
    return function(WrappedComponent) {
        // eslint-disable-next-line react/display-name
        var displayName = "withMiniLD";
        if (forwardRef) {
            var forwarded = /*#__PURE__*/ React.forwardRef(function(props, ref) {
                return(// essentially a wrapper component for the AdobeTarget wrapper
                /*#__PURE__*/ _jsx(MiniLD, {
                    LaunchDarklyConfig: {
                        clientId: clientId,
                        user: user,
                        placeholder: placeholder,
                        flag: mapPropsToFlag(props, flag)
                    },
                    children: /*#__PURE__*/ _jsx(WrappedComponent, _extends({}, props, {
                        ref: ref
                    }))
                }));
            });
            forwarded.displayName = displayName;
            return forwarded;
        }
        var notForwarded = function(props) {
            return(// essentially a wrapper component for the AdobeTarget wrapper
            /*#__PURE__*/ _jsx(MiniLD, {
                LaunchDarklyConfig: {
                    clientId: clientId,
                    user: user,
                    placeholder: placeholder,
                    flag: mapPropsToFlag(props, flag)
                },
                children: /*#__PURE__*/ _jsx(WrappedComponent, _extends({}, props))
            }));
        };
        notForwarded.displayName = displayName;
        return notForwarded;
    };
};
export { withMiniLD };

//# sourceMappingURL=withMiniLD.js.map